/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_OrganizationInputs */



/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Knp_Terms_Type_OrganizationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_organization = /** @type {((inputs?: Knp_Terms_Type_OrganizationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_OrganizationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Organizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Организация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Organización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("组织")
	if (locale === "ja") return /** @type {LocalizedString} */ ("組織")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संगठन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Organização")
	return /** @type {LocalizedString} */ ("Organization")
});